import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import LineRoundedWrapper from '../icons/exported/lineRoundedWrapper';

const UpArrowIcon = styled.svg`
  width: 16px;
  height: 16px;
  stroke: white;
  stroke-width: 2;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
`;

const Root = styled.button<{ $fullWidth?: boolean; $margin: string }>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  min-height: 50px;
  border: none;
  border-radius: 0;
  font-family: inherit;
  font-size: 16px;
  font-weight: bold;
  color: #0b0e2c;
  text-decoration: none;
  background: linear-gradient(135deg, #ffd700, #ffa500);
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  margin: ${(p) => p.$margin};
  width: ${(p) => (p.$fullWidth ? '100%' : 'auto')};

  &:hover,
  &:focus-visible {
    background: linear-gradient(135deg, #ffa500, #ff8c00) !important;
    color: #0b0e2c !important;
  }

  &:focus-visible {
    outline: 2px solid #0b0e2c;
    outline-offset: 2px;
  }
`;

export type UpgradePromoButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  /** Sidebar: full width of nav column */
  fullWidth?: boolean;
  /** e.g. sidebar uses vertical spacing from nav items */
  margin?: string;
  showIcon?: boolean;
};

const UpgradePromoButton: FC<UpgradePromoButtonProps> = ({
  children,
  onClick,
  fullWidth = false,
  margin = '12px 0',
  showIcon = true,
}) => {
  return (
    <Root type="button" $fullWidth={fullWidth} $margin={margin} onClick={onClick}>
      {showIcon && (
        <LineRoundedWrapper>
          <UpArrowIcon viewBox="0 0 24 24" aria-hidden>
            <path d="M12 19V5M5 12l7-7 7 7" />
          </UpArrowIcon>
        </LineRoundedWrapper>
      )}
      {children}
    </Root>
  );
};

export default UpgradePromoButton;
